"use strict";

var _regeneratorRuntime = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ledger = exports.LEDGER_DEFAULT_INDEX = exports.LEDGER_DEFAULT_CHANGE = exports.LEDGER_DEFAULT_ACCOUNT = void 0;

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/classPrivateFieldLooseKey"));

var _ledgerPolkadot = require("@zondax/ledger-polkadot");

var _hwLedgerTransports = require("@polkadot/hw-ledger-transports");

var _util = require("@polkadot/util"); // Copyright 2017-2021 @polkadot/hw-ledger authors & contributors
// SPDX-License-Identifier: Apache-2.0


var LEDGER_DEFAULT_ACCOUNT = 0x80000000;
exports.LEDGER_DEFAULT_ACCOUNT = LEDGER_DEFAULT_ACCOUNT;
var LEDGER_DEFAULT_CHANGE = 0x80000000;
exports.LEDGER_DEFAULT_CHANGE = LEDGER_DEFAULT_CHANGE;
var LEDGER_DEFAULT_INDEX = 0x80000000;
exports.LEDGER_DEFAULT_INDEX = LEDGER_DEFAULT_INDEX;
var SUCCESS_CODE = 0x9000; // These match up with the network keys in the @polkadot/networks package
// (which is turn aligns with the substrate/ss58-registry.json as the single
// source of truth)

var APPS = {
  dock: _ledgerPolkadot.newDockApp,
  kusama: _ledgerPolkadot.newKusamaApp,
  polkadot: _ledgerPolkadot.newPolkadotApp,
  polymesh: _ledgerPolkadot.newPolymeshApp
};

var _app = (0, _classPrivateFieldLooseKey2.default)("app");

var _chain = (0, _classPrivateFieldLooseKey2.default)("chain");

var _transport = (0, _classPrivateFieldLooseKey2.default)("transport");

var _getApp = (0, _classPrivateFieldLooseKey2.default)("getApp");

var _withApp = (0, _classPrivateFieldLooseKey2.default)("withApp");

var _wrapError = (0, _classPrivateFieldLooseKey2.default)("wrapError"); // A very basic wrapper for a ledger app -
//  - it connects automatically, creating an app as required
//  - Promises return errors (instead of wrapper errors)


var Ledger =
/*#__PURE__*/
function () {
  function Ledger(_transport2, chain) {
    var _this = this;

    _classCallCheck(this, Ledger);

    Object.defineProperty(this, _app, {
      writable: true,
      value: null
    });
    Object.defineProperty(this, _chain, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _transport, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _getApp, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var def, transport;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if ((0, _classPrivateFieldLooseBase2.default)(_this, _app)[_app]) {
                    _context.next = 7;
                    break;
                  }

                  def = _hwLedgerTransports.transports.find(function (_ref) {
                    var type = _ref.type;
                    return type === (0, _classPrivateFieldLooseBase2.default)(_this, _transport)[_transport];
                  });
                  (0, _util.assert)(def, "Unable to find a transport for ".concat((0, _classPrivateFieldLooseBase2.default)(_this, _transport)[_transport]));
                  _context.next = 5;
                  return def.create();

                case 5:
                  transport = _context.sent;
                  (0, _classPrivateFieldLooseBase2.default)(_this, _app)[_app] = APPS[(0, _classPrivateFieldLooseBase2.default)(_this, _chain)[_chain]](transport);

                case 7:
                  return _context.abrupt("return", (0, _classPrivateFieldLooseBase2.default)(_this, _app)[_app]);

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function value() {
          return _value.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(this, _withApp, {
      writable: true,
      value: function () {
        var _value2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2(fn) {
          var app;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.next = 3;
                  return (0, _classPrivateFieldLooseBase2.default)(_this, _getApp)[_getApp]();

                case 3:
                  app = _context2.sent;
                  _context2.next = 6;
                  return fn(app);

                case 6:
                  return _context2.abrupt("return", _context2.sent);

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2["catch"](0);
                  (0, _classPrivateFieldLooseBase2.default)(_this, _app)[_app] = null;
                  throw _context2.t0;

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 9]]);
        }));

        function value(_x) {
          return _value2.apply(this, arguments);
        }

        return value;
      }()
    });
    Object.defineProperty(this, _wrapError, {
      writable: true,
      value: function () {
        var _value3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3(promise) {
          var result;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return promise;

                case 2:
                  result = _context3.sent;
                  (0, _util.assert)(result.return_code === SUCCESS_CODE, result.error_message);
                  return _context3.abrupt("return", result);

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        function value(_x2) {
          return _value3.apply(this, arguments);
        }

        return value;
      }()
    }); // u2f is deprecated

    (0, _util.assert)(['hid', 'webusb'].includes(_transport2), "Unsupported transport ".concat(_transport2));
    (0, _util.assert)(Object.keys(APPS).includes(chain), "Unsupported chain ".concat(chain));
    (0, _classPrivateFieldLooseBase2.default)(this, _chain)[_chain] = chain;
    (0, _classPrivateFieldLooseBase2.default)(this, _transport)[_transport] = _transport2;
  }

  _createClass(Ledger, [{
    key: "getAddress",
    value: function () {
      var _getAddress = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _this2 = this;

        var confirm,
            accountOffset,
            addressOffset,
            _ref2,
            _ref2$account,
            account,
            _ref2$addressIndex,
            addressIndex,
            _ref2$change,
            change,
            _args5 = arguments;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                confirm = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : false;
                accountOffset = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : 0;
                addressOffset = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : 0;
                _ref2 = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : {}, _ref2$account = _ref2.account, account = _ref2$account === void 0 ? LEDGER_DEFAULT_ACCOUNT : _ref2$account, _ref2$addressIndex = _ref2.addressIndex, addressIndex = _ref2$addressIndex === void 0 ? LEDGER_DEFAULT_INDEX : _ref2$addressIndex, _ref2$change = _ref2.change, change = _ref2$change === void 0 ? LEDGER_DEFAULT_CHANGE : _ref2$change;
                return _context5.abrupt("return", (0, _classPrivateFieldLooseBase2.default)(this, _withApp)[_withApp](
                /*#__PURE__*/
                function () {
                  var _ref3 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee4(app) {
                    var _ref4, address, pubKey;

                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            _context4.next = 2;
                            return (0, _classPrivateFieldLooseBase2.default)(_this2, _wrapError)[_wrapError](app.getAddress(account + accountOffset, change, addressIndex + addressOffset, confirm));

                          case 2:
                            _ref4 = _context4.sent;
                            address = _ref4.address;
                            pubKey = _ref4.pubKey;
                            return _context4.abrupt("return", {
                              address: address,
                              publicKey: "0x".concat(pubKey)
                            });

                          case 6:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAddress() {
        return _getAddress.apply(this, arguments);
      }

      return getAddress;
    }()
  }, {
    key: "getVersion",
    value: function () {
      var _getVersion = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", (0, _classPrivateFieldLooseBase2.default)(this, _withApp)[_withApp](
                /*#__PURE__*/
                function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee6(app) {
                    var _ref6, isLocked, major, minor, patch, isTestMode;

                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            _context6.next = 2;
                            return (0, _classPrivateFieldLooseBase2.default)(_this3, _wrapError)[_wrapError](app.getVersion());

                          case 2:
                            _ref6 = _context6.sent;
                            isLocked = _ref6.device_locked;
                            major = _ref6.major;
                            minor = _ref6.minor;
                            patch = _ref6.patch;
                            isTestMode = _ref6.test_mode;
                            return _context6.abrupt("return", {
                              isLocked: isLocked,
                              isTestMode: isTestMode,
                              version: [major, minor, patch]
                            });

                          case 9:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getVersion() {
        return _getVersion.apply(this, arguments);
      }

      return getVersion;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(message) {
        var _this4 = this;

        var accountOffset,
            addressOffset,
            _ref7,
            _ref7$account,
            account,
            _ref7$addressIndex,
            addressIndex,
            _ref7$change,
            change,
            _args9 = arguments;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                accountOffset = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : 0;
                addressOffset = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 0;
                _ref7 = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {}, _ref7$account = _ref7.account, account = _ref7$account === void 0 ? LEDGER_DEFAULT_ACCOUNT : _ref7$account, _ref7$addressIndex = _ref7.addressIndex, addressIndex = _ref7$addressIndex === void 0 ? LEDGER_DEFAULT_INDEX : _ref7$addressIndex, _ref7$change = _ref7.change, change = _ref7$change === void 0 ? LEDGER_DEFAULT_CHANGE : _ref7$change;
                return _context9.abrupt("return", (0, _classPrivateFieldLooseBase2.default)(this, _withApp)[_withApp](
                /*#__PURE__*/
                function () {
                  var _ref8 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee8(app) {
                    var buffer, _ref9, signature;

                    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            buffer = (0, _util.u8aToBuffer)(message);
                            _context8.next = 3;
                            return (0, _classPrivateFieldLooseBase2.default)(_this4, _wrapError)[_wrapError](app.sign(account + accountOffset, change, addressIndex + addressOffset, buffer));

                          case 3:
                            _ref9 = _context8.sent;
                            signature = _ref9.signature;
                            return _context8.abrupt("return", {
                              signature: (0, _util.u8aToHex)((0, _util.bufferToU8a)(signature))
                            });

                          case 6:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8);
                  }));

                  return function (_x6) {
                    return _ref8.apply(this, arguments);
                  };
                }()));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sign(_x5) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }]);

  return Ledger;
}();

exports.Ledger = Ledger;